import React, { useEffect, useRef } from 'react';

/**
 * Component to force-redirect the interface to the php dashboard. This is used with the EULA process to allow the interface to be redirected using history push-state
 */

function RedirectToMain({ 'data-test': dataTest }) {
  // the ref is used to allow DOM interactions, in this case simulating a click on a link
  const linkRef = useRef();
  useEffect(() => {
    linkRef.current.click();
  }, []); // eslint-disable-line

  return (
    <a
      data-test={dataTest || 'redirect-link'} 
      href="/main/device_main.php"
      id="redirect"
      ref={linkRef}
      className="visually-hidden">
      Redirect to main
    </a>
  );
}

export default RedirectToMain;
